import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'https://api.eyeconx.com/v1/public/';
const API_SMS_GATEWAY = process.env.REACT_APP_GATEWAY_URL || "https://gateway.eyeconx.com/gateway/v1/public/sms-confirmation";

let axiosConfig = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*',
    }
  };
const getClinicByShortCode=(shortcode)=>{
    return axios.get(API_URL+shortcode,axiosConfig);
}

const addComment = (id,data)=>{
    return axios.post(API_URL+"reputation/"+id+"/comments",data);
}

const getLinks = (id)=>{
    return axios.get(API_URL+"reputation/"+id+"/links");
}
const addFeedback = (id,data)=>{
    return axios.post(API_URL+"reputation/"+id+"/feedback",data);
}
const getPatientPref = (clinicId,patientId,uuid,type,data)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/welcome/"+uuid+"?type="+type+"&data="+data)
}
const getHours =(clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/clinic-hours")
}
const updatePatientPref = (clinicId,patientId,uuid,type,data,prefValue)=>{
    return axios.put(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/preferences/"+uuid+"?type="+type+"&data="+data,prefValue)
}
const clorder = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/cl-orders",data)
}
const unsubscribe = (clinicId,patientId,uuid,type,data)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/patients/"+patientId+"/unsubscribe/"+uuid+"?type="+type+"&data="+data)
}
const getArticle = (clinicId,articleId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/articles/"+articleId)
}
const getGatewayClinicInfo = (clinicId,messageId) =>{
    const formData = new FormData();
    formData.append("clinicId", clinicId);
    formData.append("messageId", messageId);
   
    return axios.post(API_SMS_GATEWAY, formData,{
        headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin':'*',
        }
    })
}
export default {
    getClinicByShortCode,
    addComment,
    getLinks,
    addFeedback,
    getPatientPref,
    getHours,
    updatePatientPref,
    clorder,
    unsubscribe,
    getArticle,
    getGatewayClinicInfo
}